'use client';

import React from 'react';
import { WidgetId } from '@/edge/constants';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import { useGetBrowserDetails, useGetOsDetails } from '@/shared/modules/user-agent';
import { BROWSER_NAME, OS_TYPE } from '@/shared/modules/user-agent/constants';
import * as Styled from './download-message.styled';
import { useIsChromeWithTopDownloads } from './hooks/use-is-chrome-with-top-downloads';
import { getCurrentArrowIconUrl } from './utils/get-current-arrow-icon-url';
const TIMEOUT_HIDE_ARROW = 1000 * 30;
const ARROW_WIDTH = 238;
const ARROW_HEIGHT = 239;
interface DownloadMessageProps {
  appId: number;
}
const TopArrow: React.FC<Edge.WidgetDownloadMessage> = (widgetDownloadMessage: Edge.WidgetDownloadMessage) => {
  return <Styled.WrapperTop data-sentry-element="unknown" data-sentry-component="TopArrow" data-sentry-source-file="download-message.tsx">
      <Styled.TextContentTopArrow html={widgetDownloadMessage.strings.downloadAdviceTextIEFF} data-sentry-element="unknown" data-sentry-source-file="download-message.tsx" />
    </Styled.WrapperTop>;
};
export const DownloadMessage = React.memo(function DownloadMessage({
  appId
}: DownloadMessageProps) {
  console.log('[DownloadMessage] appId', appId);
  const [isComplete, setIsComplete] = React.useState(false);
  const {
    browserName
  } = useGetBrowserDetails();
  const {
    osType
  } = useGetOsDetails();
  const isChromeWithTopDownloads = useIsChromeWithTopDownloads();
  const widgetDownloadMessage = useEdgeConfigWidget(WidgetId.DownloadMessage);
  const timeoutRef = React.useRef<NodeJS.Timeout>();
  const {
    downloadAdviceTextIOS,
    downloadAdviceTextWin
  } = widgetDownloadMessage.strings;
  const currentArrowIconUrl = getCurrentArrowIconUrl(widgetDownloadMessage, appId);
  const arrowText = osType === OS_TYPE.MAC_OS ? downloadAdviceTextIOS : downloadAdviceTextWin;
  const isChrome = browserName === BROWSER_NAME.CHROME;
  const isEdge = browserName === BROWSER_NAME.MICROSOFT_EDGE;
  const isFF = browserName === BROWSER_NAME.FIREFOX;
  const isBrowserWithTopDownloads = isEdge || isFF || isChromeWithTopDownloads;
  React.useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setIsComplete(true);
    }, TIMEOUT_HIDE_ARROW);
    return () => {
      timeoutRef && timeoutRef.current && clearTimeout(timeoutRef.current);
    };
  }, []);
  if (!isComplete && isBrowserWithTopDownloads) {
    return TopArrow(widgetDownloadMessage);
  }
  if (!currentArrowIconUrl || !isChrome || isComplete) {
    return null;
  }
  return <React.Fragment>
      <Styled.Wrapper>
        <Styled.ArrowIcon src={currentArrowIconUrl} alt="Download arrow" width={ARROW_WIDTH} height={ARROW_HEIGHT} />
        <Styled.TextContent html={arrowText} />
      </Styled.Wrapper>
    </React.Fragment>;
});